export const FONT_FAMILY = "'Roboto', sans-serif"
export const BASE_COLOR = '39, 102, 150' // DHIS2 blue



// WEBPACK FOOTER //
// ./src/config/style.config.js